import { render } from "./TranslateClassification.vue?vue&type=template&id=f8ac1c74"
import script from "./TranslateClassification.vue?vue&type=script&lang=js"
export * from "./TranslateClassification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__